

export function styler(style: HTMLStyleElement, scopedId: string): HTMLStyleElement | void {
    if (!style || !scopedId)
        return;
    const result = document.createElement("style");
    result.textContent = style.textContent?.replace(/((#[a-z0-9_\-.]+)|(\.[a-z0-9_\-.]+)|([a-z0-9_\-]+(?=.*{)))/ig, "#" + scopedId + " $1") as string;
    return result;
}